import React, {useEffect, useMemo, useRef, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import useQueryCampaigns from '../../../hooks/api/campaign/useQueryCampaigns'
import WizButton from '../../../components/button/WizButton'
import useNavigation from '../../../hooks/useNavigation'
import TableLayout from '../../../components/table/TableLayout'
import TableItem from '../../../components/table/TableItem'
import WizImage from '../../../components/image/WizImage'
import img_lot_main from '../../../assets/images/img_lot_main.jpg'
import Text from '../../../components/text/Text'
import TableHeader from '../../../components/table/TableHeader'
import {campaignsType} from '../../../apis/campaign/getCampaigns'
import DeleteCampaignModal from '../../../features/page/leaderboard/campaign/DeleteCampaignModal'

interface IProps {
    className?: string
}

const CampaignPage: React.FC<IProps> = ({className}) => {
    const {goCampaignCreate, goCampaignDetail} = useNavigation()
    const [campaignStatus, setCampaignStatus] = useState<campaignsType>('open')

    const {data, refetch} = useQueryCampaigns(campaignStatus)

    const onClickAction = (action, type) => {
        if (type === 'web' || type === 'deeplink') {
            window.open(action)
        } else if (type === 'post') {
            window.open(`https://leagueoftraders.io/post/${action}`)
        } else if (type === 'league') {
            window.open(`https://leagueoftraders.io/leaderboard?tab=league&league=${action}`)
        }
    }

    const deleteCampaignRef = useRef<any>()

    const campaignList = useMemo(() => {
        return data?.data?.sort((a, b) => b.sorting - a.sorting)
    }, [data])

    const onClickRemoveCampaign = (id?: string) => {
        deleteCampaignRef?.current?.show(id)
    }

    useEffect(() => {
        refetch()
    }, [campaignStatus])

    return (
        <PageLayout title={campaignStatus === 'open' ? 'Open Bottom Sheet' : 'Close Bottom Sheet'}>
            <div className={'space-x-[10px] sm:space-x-0 sm:space-y-[10px]'}>
                <WizButton
                    text={`Show ${campaignStatus === 'close' ? 'Open' : 'Close'} Bottom Sheet`}
                    type={campaignStatus === 'close' ? 'primary' : 'gray'}
                    onClick={() => {
                        setCampaignStatus(campaignStatus === 'close' ? 'open' : 'close')
                    }}
                    className={'sm:block'}
                />
                <WizButton
                    text={'Create Bottom Sheet'}
                    type={'primary'}
                    className={'sm:block'}
                    onClick={goCampaignCreate}
                />
            </div>

            <div className={'mt-[30px] '}>
                <TableHeader className={'grid-cols-2 gap-x-[10px] md:hidden'}>
                    <Text>Bottom Sheet</Text>
                    <Text className={'text-center'}>Options</Text>
                </TableHeader>
                <TableLayout>
                    {campaignList?.map(campaign => {
                        return (
                            <TableItem
                                onClick={() => {
                                    goCampaignDetail(campaign?.id)
                                }}
                                key={campaign?.id}
                                className={'grid-cols-[1fr_2fr] gap-x-[10px] md:block md:space-y-[30px] sm:px-[15px]'}>
                                <div
                                    className={
                                        'flex items-center gap-x-[20px] md:flex-col md:justify-center md:space-y-[15px]'
                                    }>
                                    <div className={'flex gap-x-[20px]'}>
                                        <div
                                            className={
                                                'relative w-[140px] rounded-[5px] overflow-hidden sm:mx-auto md:w-[180px]'
                                            }>
                                            <WizImage src={img_lot_main} className={'relative brightness-[0.5]'} />
                                            <div
                                                style={{backgroundColor: campaign?.background_color?.light}}
                                                className={`pt-[10px] absolute bottom-0 left-0 w-full z-[1] rounded-tl-[5px] rounded-tr-[5px]`}>
                                                <WizImage
                                                    src={`${campaign?.background_image}?type=webp&width=1000&quality=100`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'space-y-[7px] sm:text-center flex-1 md:text-center'}>
                                        <Text className={'text-ti2 md:text-ti1'}>{campaign?.name}</Text>
                                        <div>
                                            <Text className={'text-font03 text-body3'}>
                                                Start At : {new Date(campaign?.start_at).toLocaleString()}
                                            </Text>
                                            <Text className={'text-font03 text-body3'}>
                                                End At : {new Date(campaign?.end_at).toLocaleString()}
                                            </Text>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={
                                        'grid grid-cols-5 lg:grid-cols-4 w-full items-center gap-[20px] md:truncate justify-between'
                                    }>
                                    <div>
                                        <div className={'text-center'}>
                                            <Text className={'text-ti3 text-font03'}>Sorting</Text>
                                            <Text className={'text-ti1'}>{campaign?.sorting}</Text>
                                        </div>
                                    </div>
                                    <div className={' text-center'}>
                                        <Text className={'text-ti3 text-font03'}>Link Type</Text>
                                        <Text className={'text-ti1'}>{campaign?.action_type}</Text>
                                    </div>
                                    <div className={' text-center md:truncate'}>
                                        <Text className={'text-ti3 text-font03'}>Link</Text>
                                        <Text className={'break-all whitespace-wrap text-ti1 sm:text-ti2 md:truncate'}>
                                            {campaign?.action}
                                        </Text>
                                    </div>
                                    <div className={'lg:hidden'}>
                                        <div className={'text-center'}>
                                            <Text className={'text-ti3 text-font03'}>Background Color</Text>
                                            <div className={'flex items-center gap-x-[5px] justify-center'}>
                                                <Text className={`text-ti2 `}>
                                                    Dark : {campaign?.background_color?.dark}
                                                </Text>
                                                <div
                                                    style={{backgroundColor: campaign?.background_color?.dark}}
                                                    className={
                                                        'w-[16px] h-[16px] border border-line01 rounded-[3px]'
                                                    }></div>
                                            </div>
                                        </div>
                                        <div className={' text-center'}>
                                            <div className={'flex items-center gap-x-[5px] justify-center'}>
                                                <Text className={`text-ti2 `}>
                                                    Light : {campaign?.background_color?.light}
                                                </Text>
                                                <div
                                                    style={{backgroundColor: campaign?.background_color?.dark}}
                                                    className={
                                                        'w-[16px] h-[16px] border border-line01 rounded-[3px]'
                                                    }></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'text-center sm:mt-[10px]'}>
                                        <WizButton
                                            text={'Delete'}
                                            type={'red'}
                                            onClick={e => {
                                                e.stopPropagation()
                                                onClickRemoveCampaign(campaign?.id)
                                            }}
                                            className={'mx-auto'}
                                        />
                                    </div>
                                </div>
                            </TableItem>
                        )
                    })}
                </TableLayout>
                <DeleteCampaignModal ref={deleteCampaignRef} />
            </div>
        </PageLayout>
    )
}

export default CampaignPage
